import {
	mapActions,
	mapGetters
} from 'vuex';

import Students from '@/domains/student/students';
import ClassList from '@/domains/school/class-list/main';

import {
	Card,
	Pagination
} from 'element-ui';

import {
	EventBus
} from '@/support/event-bus';

import PageBar from '@/components/page-bar/page-bar';
import ClassGrade from '@/domains/school/class-grade/main';
import SchoolClassList from '@/domains/school/class-list/main';

import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

import toastr from '@/support/toastr';

export default {
	state,
	actions,
	mutations,
	getters,
	name: 'gallery',
	components: {
		PageBar,
		ClassGrade,
		SchoolClassList,
		Students,
		Pagination,
		Card,
		ClassList,

	},
	data: () => ({
		albumName: '',
		payloadFilter: {},
		studentName: '',
		scopeFilter: '',
		classList: ''
	}),
	computed: {
		...mapGetters([
			'getLoggedUser',
			'list',
			'settings',
			'ENUM',
			'getClass'
		])
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'setAlbunsList',
			'publishAlbum',
			'unpublishAlbum',
			'setAlbum',
			'getAlbumList'
		]),
		filter() {
			const queryFilter = {
				description: this.albumName,
				studentName: this.studentName,
				scope: this.scopeFilter,
				schoolClassId: this.getClass.schoolClassId
			};

			return this.setAlbunsList({
				userId: this.getLoggedUser.id,
				filter: queryFilter
			});
		},
		publish(id) {

			this.publishAlbum({
				id: id,
				userId: this.getLoggedUser.id,
			}).then(() => {
				toastr.success(this.$gettext('Álbum publicado com sucesso!'));
				EventBus.$emit('albumListChange');
			});
		},
		unpublish(id) {

			this.unpublishAlbum({
				id: id,
				userId: this.getLoggedUser.id,
			}).then(() => {
				toastr.success(this.$gettext('Álbum despublicado com sucesso!'));
				EventBus.$emit('albumListChange');
			});

		},
		handleCurrentChange(page) {

			this.payloadFilter.pagination = {
				quantity: this.settings.Pagination.pageSize,
				page: (page - 1),
				albumName: this.albumName
			};

			this.payloadFilter.userId = this.getLoggedUser.id;

			this.getAlbumList(this.payloadFilter);
		}
	},
	beforeDestroy() {
		EventBus.$off('albumListChange');
	},
	mounted() {

		this.handleCurrentChange(1);

		this.setBreadcrumb([{
			text: 'Administrativo'
		}, {
			text: 'Galeria'
		}]);

		EventBus.$on('albumListChange', () => {

			this.setAlbunsList({
				userId: this.getLoggedUser.id,
				albumName: this.albumName
			});

		});

	}
};


// WEBPACK FOOTER //
// ./sources/app/gallery/index.js